import PatientBrowser from "../../patients/PatientBrowser";

const PatientListingSidebar = props => {
    return <>
        <PatientBrowser showShortcuts mt={4} getPatientLink={(item) => `/patient/${item.id}`} />
    </>
};

export default PatientListingSidebar;
